module.exports = __webpack_public_path__ + "img/pocket.13aba37.png";